import angular from "angular";
import controller from "./admin-documents.controller";
import template from "./admin-documents.html";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.documents", {
    url: "/documents",
    controller: "AdminDocumentsController",
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.documents", [])
  .config(config)
  .controller("AdminDocumentsController", controller);
